
<!-- 用户信息-->
<template>
  <a-form class="user-info" :model="userInfo" :colon="false" labelAlign="left">
    <teleport to="body">
      <div v-if="uploading" class="avatar-upload-tip">
        <a-spin size="large" />
      </div>
    </teleport>
    <a-form-item label="头像">
      <div @click="openUpload" :style="userInfo.avatarStyle" class="avatar-box">
        <input id="uploadInput" @click.stop @change="upload" type="file">
      </div>
    </a-form-item>

    <a-form-item label="昵称">
      <a-input v-model:value="userInfo.nickName" maxLength="20"/>
    </a-form-item>

    <a-form-item label="性别">
      <a-radio-group v-model:value="userInfo.sex">
        <a-radio :value="1">男</a-radio>
        <a-radio :value="2">女</a-radio>
        <a-radio :value="0">保密</a-radio>
      </a-radio-group>
    </a-form-item>

    <a-form-item class="item-uid" label="UID">
      <span class="value">{{userInfo.uid}}</span>
    </a-form-item>

    <a-form-item :wrapper-col="{ span: 14, offset: 4 }">
      <a-button class="submit-btn" type="primary" @click="onSubmit">保存</a-button>
    </a-form-item>
  </a-form>
</template>
<script setup>
import { getUserInfo, onSubmit, uploadAvatar, triggerInput } from '@/utils/setup/userInfo';
import { onBeforeMount, computed, ref, nextTick } from 'vue';
import { useStore } from 'vuex';

const store = useStore();
const userInfo = computed(() => store.state.userInfo);
const uploading = ref(false);

onBeforeMount(() => {
  getUserInfo();
});

function openUpload (event) {
  if (!uploading.value) {
    triggerInput(event);
  }
}

async function upload (event) {
  uploading.value = true;
  await nextTick();
  await new Promise(resolve => requestAnimationFrame(resolve));
  try {
    await uploadAvatar(event);
  } finally {
    uploading.value = false;
  }
}
</script>

<style lang="scss">
.user-info {
  .avatar-box {
    position: relative;
    width: 40px;
    height: 40px;
    overflow: hidden;
    border-radius: 50%;
    cursor: pointer;
    //border: v-bind('avatarBorder');
    .pic {
      width: 100%
    }
    input {
      position: absolute;
      top: -40px;
      left: -40px;
    }
  }
  .ant-form-item-label {
    width: 80px;
    > label {
      color: #2b364a;
      font-size: 16px;
    }
  }
  .ant-input {
    width: 400px;
  }
  .item-uid .value {
    color: #abb2bd;
    font-size: 16px;
  }
  .submit-btn {
    height: 32px;
    width: 120px;
  }
}

</style>

<style lang="scss">
.avatar-upload-tip {
  position: fixed;
  z-index: 9999;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background: rgba(0, 0, 0, 0.25);
  pointer-events: all;
}
</style>
